import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import accountReducer from "~@/store/commons/account.slice";
import agendaSlice from "~@/store/commons/agenda.slice";
import channelsReducer from "~@/store/commons/channels.slice";
import chatRoomReducer from "~@/store/commons/chatRoom.slice";
import chatsAssigningReducer from "~@/store/commons/chatsAssigning.slice";
import chatsCountReducer from "~@/store/commons/chatsCount.slice";
import currentClientReducer from "~@/store/commons/currentClient.slice";
import dashboardReducer from "~@/store/commons/dashboard.slice";
import eventCreationReducer from "~@/store/commons/eventCreation.slice";
import inventoryReducer from "~@/store/commons/inventory.slice";
import inventoryUploadReducer from "~@/store/commons/inventoryUpload.slice";
import operatorsReducer from "~@/store/commons/operators.slice";
import organizationReducer from "~@/store/commons/organization.slice";
import packagesSettingsReducer from "~@/store/commons/packagesSettings.slice";
import pricingReducer from "~@/store/commons/pricing.slice";
import teamsReducer from "~@/store/commons/teams.slice";
import verificationReducer from "~@/store/commons/verification.slice";

const agendaReducer = combineReducers({
  common: agendaSlice,
  eventCreation: eventCreationReducer,
});

const chatsReducer = combineReducers({
  chatsCount: chatsCountReducer,
  chatsAssigning: chatsAssigningReducer,
});

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    chats: chatsReducer,
    chatRoom: chatRoomReducer,
    agenda: agendaReducer,
    currentClient: currentClientReducer,
    teams: teamsReducer,
    operators: operatorsReducer,
    channels: channelsReducer,
    account: accountReducer,
    inventory: inventoryReducer,
    inventoryUpload: inventoryUploadReducer,
    organization: organizationReducer,
    packages: packagesSettingsReducer,
    pricing: pricingReducer,
    verification: verificationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
